angular.module('TetherApp').controller('FulfilmentBatchController', [
    'fulfilmentBatchService',
    function (fulfilmentBatchService) {

        let ctrl = this;

        let fulfilmentBatch = {};
        ctrl.batchable = [];

        let onError = function(reason) {
            ctrl.error = 'Could not fetch the data.';
        };

        ctrl.getBatchable = function () {
            fulfilmentBatchService.batchableExperiences()
                .then(onGetBatchable, onError);
        };

        let onGetBatchable = function (data) {
            ctrl.batchable = data;
        };

        ctrl.experienceChanged = function() {

        };

    }
]);
